// @flow
import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation ArticleDeleteMutation(
    $input: ArticleDeleteInput!
    ) {
        ArticleDelete (input: $input) {
            error
        }
    }
`;
// const mutation = graphql`
//     mutation ArticleDeleteMutation(
//     $id: String!
//     ) {
//         AricleDelete (input: {id: $id}) {
//           error
//       }
//     }
// `;

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
    console.log(params);
    commitMutation(
        environment,
        {
            mutation: mutation,
            variables: {
                input: params,
            },
            // onCompleted: () => {
            //     const r = response.ArticleDelete;
            //     console.log(`mutation resp: ${JSON.stringify(r)}`);
            //     if (r.error !== null) {
            //         callback(r.error, null);
            //         return;
            //     }
            //
            //     callback(null, r.article.id);
            // },
            onError: (error) => {
                console.log("error mutating");
                console.log(error);
                callback(error, null);
            },
        },
    );
}



// WEBPACK FOOTER //
// src/mutations/ArticleDeleteMutation.js